export type ThanksPlacement = 'applicationSubmitted' | 'viewingRegistration'
export type ThanksDisplayMode = 'popup' | 'embedded'

export const THANKS_PARTNER_IDS: Record<ThanksPlacement, string> = {
  applicationSubmitted:
    process.env.REACT_APP_THANKS_PARTNER_ID_APPLICATION_SUBMITTED || '',
  viewingRegistration:
    process.env.REACT_APP_THANKS_PARTNER_ID_VIEWING_REGISTRATION || '',
}

export const getThanksPartnerId = (placement: ThanksPlacement): string => {
  return THANKS_PARTNER_IDS[placement]
}

export const THANKS_KEYWORDS: Record<ThanksPlacement, string[]> = {
  applicationSubmitted: ['rental-application', 'lease', 'moving'],
  viewingRegistration: ['viewing', 'inspection', 'rental-viewing'],
}

export const THANKS_CATEGORIES = ['real-estate', 'rental']

export const THANKS_SLOT_BY_PLACEMENT: Record<ThanksPlacement, string> = {
  applicationSubmitted: '360X144',
  viewingRegistration: '320X100',
}

export const THANKS_DISPLAY_MODE_BY_PLACEMENT: Record<
  ThanksPlacement,
  ThanksDisplayMode
> = {
  applicationSubmitted: 'embedded',
  viewingRegistration: 'embedded',
}

const THANKS_POPUP_ESTIMATED_HEIGHT_PX = 420
const THANKS_POPUP_MIN_TOP_OFFSET_PX = 16

export const getCenteredThanksPopupTopOffset = (): number => {
  if (typeof window === 'undefined') return THANKS_POPUP_MIN_TOP_OFFSET_PX

  const centeredTop =
    window.scrollY + (window.innerHeight - THANKS_POPUP_ESTIMATED_HEIGHT_PX) / 2

  return Math.max(
    window.scrollY + THANKS_POPUP_MIN_TOP_OFFSET_PX,
    Math.round(centeredTop),
  )
}
